<template>
    <yams-template>
        <template #header>
            <div class="mr-5">
                <h4>Paiement</h4>
            </div>
        </template>
        <template #content>
            <div class="d-flex justify-content-center align-items-center vh-100 bg-light">
                <div class="text-center">
                    <!-- Icône animée -->
                    <i class="fas fa-check-circle text-success fa-5x mb-3 animated-icon"></i>
                    <!-- Message -->
                    <h4 class="text-success">Paiement effectué avec succès</h4>
                </div>
            </div>
        </template>
    </yams-template>
</template>

<script>
export default {
    name: "PaymentSuccess",
};
</script>

<style scoped>
/* Animation simple scale + fade */
@keyframes pop {
    0% {
        transform: scale(0.3);
        opacity: 0;
    }

    80% {
        transform: scale(1.1);
        opacity: 1;
    }

    100% {
        transform: scale(1);
    }
}

.animated-icon {
    animation: pop 0.6s ease-in-out;
}
</style>